import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {VerifyEmailStep} from '@mintdata-wsp/common/state/UIState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {bind} from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const st = require('./EmailVerificationDialog.less');
const cx = classnames.bind(st);

export type CloseHandler = () => void;
export type ClickDeleteHandler = () => void;

export interface IEmailNotVerifiedDialogState
{
    // isVerificationRequested:boolean;
}

@observer
export class EmailNotVerifiedDialog extends React.Component <any, IEmailNotVerifiedDialogState>
{
    constructor()
    {
        super();

        // this.state = {
        //     isVerificationRequested: false
        // };
    }

    private _onContactUsClick(event:React.MouseEvent<HTMLElement>):void
    {
        event.preventDefault();
        controllers.analytics.intercom.show();
    }

    @bind
    private _onResendEmail()
    {
        const {verifyEmail} = rootState.ui;

        verifyEmail.setStep(VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL);

        // this.setState({isVerificationRequested: true});

        controllers.user
            .resendVerificationEmail()
            .then(() =>
            {
                verifyEmail.setStep(VerifyEmailStep.JUST_SEND);
            });
    }

    @bind
    private _onClose()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.EmailVerification);
    }

    private _renderVerificationSent()
    {
        const {email} = rootState.userSession.currentUser;

        return (
            <Row>
                <Row className={st.dialogIcon}>
                    <img
                        className={st.icon56}
                        src={'/assets/images/home/icon-56-email.svg'}
                        alt=""
                    />
                </Row>
                <div>
                    <b>You are almost there!</b> We sent an email to <br />
                    <b className={st.colorLink}>{email}</b>
                    <br /><br />
                    <b>Just click on the link</b> in that email to complete your signup. <br />
                    If you don’t see it, you may need to check your spam folder.
                </div>
            </Row>
        );
    }

    private _renderVerified()
    {
        return (
            <Row>
                <Row className={st.dialogIcon}>
                    <img
                        className={cx(st.icon56, st.iconOneLine)}
                        src={'/assets/images/home/icon-56-check-blue.svg'}
                        alt=""
                    />
                </Row>
                <div>
                    Your email address has been verified.
                </div>
            </Row>
        );
    }

    private _renderFailed()
    {
        return (
            <Row>
                <Row className={st.dialogIcon}>
                    <img
                        className={cx(st.icon56, st.iconOneLine)}
                        src={'/assets/images/home/icon-56-check-red.svg'}
                        alt=""
                    />
                </Row>
                <div>
                    The verification code does not match our record.
                </div>
            </Row>
        );
    }

    private _renderContent()
    {
        const {verifyEmail} = rootState.ui;

        switch( verifyEmail.step )
        {
            case VerifyEmailStep.NEEDS_VERIFICATION:
            case VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL:
            case VerifyEmailStep.JUST_SEND:
                return this._renderVerificationSent();

            case VerifyEmailStep.VERIFIED:
                return this._renderVerified();

            case VerifyEmailStep.FAILED:
                return this._renderFailed();

            default:
                return null;
        }
    }

    private _getSpinner():JSX.Element
    {
        return (
            <Spinner
                className={st.btnSpinner}
                size={SpinnerSize.Medium_24}
                style={SpinnerStyle.White}
            />
        );
    }

    private _renderButton()
    {
        const {verifyEmail} = rootState.ui;
        // const {isVerificationRequested} = this.state;

        switch( verifyEmail.step )
        {
            case VerifyEmailStep.NEEDS_VERIFICATION:
            case VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL:
            case VerifyEmailStep.JUST_SEND:
            case VerifyEmailStep.FAILED:

                const icon:JSX.Element | string = verifyEmail.step == VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL
                    ? this._getSpinner()
                    : MDIcons.common.Email;

                const caption:string = verifyEmail.step == VerifyEmailStep.JUST_SEND
                    ? 'Just sent'
                    : 'Resend email';

                const isDisabled:boolean = verifyEmail.step == VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL ||
                    verifyEmail.step == VerifyEmailStep.JUST_SEND;

                return (
                    <Column>
                        {
                            verifyEmail.step != VerifyEmailStep.FAILED &&
                            <div className={st.btnsHelper}>
                                <b>Can’t find the email?</b>
                            </div>
                        }
                        <DialogButton
                            className={cx(st.dialogBtn)}
                            caption={caption}
                            intent={MDIntent.Default}
                            style={ButtonStyle.Raised}
                            onClick={this._onResendEmail}
                            isDisabled={isDisabled}
                            icon={icon}
                            iconClassName={cx(st.dialogBtnIcon)}
                        />
                    </Column>
                );

            case VerifyEmailStep.VERIFIED:
                return (
                    <Column>
                        <DialogButton
                            className={cx(st.dialogBtn, st.dialogBtnArrow)}
                            caption={'Go to Workspace'}
                            intent={MDIntent.Default}
                            style={ButtonStyle.Raised}
                            onClick={this._onClose}
                            icon={MDIcons.common.KeyboardBackspace}
                            iconClassName={cx(st.dialogBtnIcon)}
                        />
                    </Column>
                );

            default:
                return null;
        }
    }

    private _renderContactUs()
    {
        const {verifyEmail} = rootState.ui;

        switch( verifyEmail.step )
        {
            case VerifyEmailStep.NEEDS_VERIFICATION:
            case VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL:
            case VerifyEmailStep.JUST_SEND:
                return (
                    <Row className={st.contactUsRow}>

                        Need help?

                        <a
                            href="#"
                            className={st.contactUsLink}
                            onClick={(event) => this._onContactUsClick(event)}
                        >
                            Contact us
                        </a>

                    </Row>
                );

            default:
                return null;
        }
    }

    // ---------------------------------------

    private _clickDebugBtn = (step:VerifyEmailStep) =>
    {
        const {verifyEmail} = rootState.ui;

        // this.setState({
        //     isVerificationRequested: step === VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL ||
        //         step === VerifyEmailStep.JUST_SEND
        // });

        requestAnimationFrame(() =>
        {
            controllers.ui.dialogs.hideDialog(Dialogs.EmailVerification);

            verifyEmail.setStep(step);

            const isModal:boolean = step !== VerifyEmailStep.VERIFIED;

            controllers.ui.dialogs.showDialog(Dialogs.EmailVerification, isModal, null, isModal);
        });
    };

    private _renderDebugBtn = (step:VerifyEmailStep) =>
    {
        const {verifyEmail} = rootState.ui;

        return (
            <div className={cx(st.debugBtn, {active: step === verifyEmail.step})}
                 onClick={() => this._clickDebugBtn(step)}
            >
                {step}
            </div>
        );
    };

    private _renderDebugBtns = () =>
    {
        if( ConfigUtil.isProd() ) return null;

        return (
            <div className={st.debug}>
                {this._renderDebugBtn(VerifyEmailStep.NEEDS_VERIFICATION)}
                {this._renderDebugBtn(VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL)}
                {this._renderDebugBtn(VerifyEmailStep.JUST_SEND)}
                {this._renderDebugBtn(VerifyEmailStep.IN_PROGRESS_VERIFY_EMAIL)}
                {this._renderDebugBtn(VerifyEmailStep.VERIFIED)}
                {this._renderDebugBtn(VerifyEmailStep.FAILED)}
            </div>
        );
    };

    // ---------------------------------------

    public render():JSX.Element
    {
        let titleClassName:string = '';
        let title:string = '';
        let isShowBlueCorner:boolean = false;

        const {verifyEmail} = rootState.ui;

        switch( verifyEmail.step )
        {
            case VerifyEmailStep.NEEDS_VERIFICATION:
            case VerifyEmailStep.IN_PROGRESS_RESEND_EMAIL:
            case VerifyEmailStep.JUST_SEND:
                title = 'Please verify your email';
                titleClassName = cx(st.dialogTitle);
                isShowBlueCorner = true;
                break;

            case VerifyEmailStep.VERIFIED:
                title = 'Thanks!';
                titleClassName = cx(st.dialogTitle, st.titleVerified);
                break;

            case VerifyEmailStep.FAILED:
                title = 'Email verification failed!';
                titleClassName = cx(st.dialogTitle, st.titleFailed);
                break;
        }

        if( verifyEmail.step == VerifyEmailStep.IN_PROGRESS_VERIFY_EMAIL )
        {
            return this._renderDebugBtns();
        }

        const isCanClose:boolean = verifyEmail.step == VerifyEmailStep.VERIFIED;

        return (
            <Dialog
                className={st.newStyleOfDialog}
                title={title}
                titleClassName={titleClassName}
                onClose={isCanClose ? this._onClose : null}
            >
                {
                    isShowBlueCorner &&
                    <img
                        className={st.blueCorner}
                        src={'/assets/images/home/blue-corner.svg'}
                        alt=""
                    />
                }

                <Column className={st.dialogContent}>

                    {this._renderContent()}

                    <Column className={st.btns}>
                        {this._renderButton()}
                        {this._renderContactUs()}
                    </Column>

                </Column>

                {this._renderDebugBtns()}

            </Dialog>
        );
    }
};
